import { BaseVideoControls } from "../../../../../../components/app-video/video-models";
import { UGCList } from "../../../../../../models/home-rows";
import { ProductLike } from "../../components/ProductLike/ProductLike.component";
import { ProductShare } from "../../components/ProductShare/ProductShare.component";
import { ProfileDetail } from "../../components/ProfileDetail/ProfileDetail.component";
import { ImageProgressControl } from "../../components/ProgressControl/ImageProgressControl/ImageProgressControl.component";
import { VideoProgressControl } from "../../components/ProgressControl/VideoProgressControl/VideoProgressControl.component";
import { ImagePlayerAction } from "../../modal/funUGCModal.component";
import { FileType } from "../../models/funUgc.model";
import styles from "./UgcPlayerControllerMobile.module.scss";

interface UgcPlayerControllerMobileProps extends BaseVideoControls {
  ugc: UGCList;
  fileType: FileType;
  rowMode: number;
  imageState: ImagePlayerAction;
  setImageState: React.Dispatch<React.SetStateAction<ImagePlayerAction>>;
  onNext: () => void;
  onPrevious: () => void;
}

function UgcPlayerControllerMobile({
  ugc,
  fileType,
  state,
  rowMode,
  imageState,
  onNext,
  onPrevious,
  setAction,
  setImageState
}: UgcPlayerControllerMobileProps) {
  return (
    <div className={styles.container}>
      <div className={styles.progressbarWrapper}>
        <ProfileDetail ugc={ugc} />

        {fileType &&
          (fileType === "Dub" ||
            fileType === "Story" ||
            fileType === "Dubsmash" ||
            fileType === "Gallery") && (
            <VideoProgressControl
              state={state}
              setAction={setAction}
              onNext={onNext}
            />
          )}

        {fileType && (fileType === "Painting" || fileType === "Coloring") && (
          <ImageProgressControl
            imageState={imageState}
            onNext={onNext}
            setImageState={setImageState}
          />
        )}

        {ugc && (
          <div className={styles.shareAndLikeWrapper}>
            <div className={styles.shareWrapper}>
              <ProductShare ugc={ugc} />
            </div>
            <div className={styles.likeWrapper}>
              <ProductLike ugc={ugc} rowMode={rowMode} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UgcPlayerControllerMobile;
